export const enum Tutorial {
  Intro = 'INTRO',
  Mix = 'MIX',
  Guide = 'GUIDE',
}
